import { gql } from '@apollo/client';

export const PromocodeFields = gql`
  fragment PromocodeFields on Promocode {
    id
    name
    amount
    chargeSubject
  }
`;
